import { render } from "./gaji-list-custom.vue?vue&type=template&id=20c17a50&scoped=true"
import script from "./gaji-list-custom.vue?vue&type=script&lang=js"
export * from "./gaji-list-custom.vue?vue&type=script&lang=js"

import "./gaji-list-custom.vue?vue&type=style&index=0&id=20c17a50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c17a50"]])

export default __exports__